var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleStyle"},[_c('div',{staticClass:"ts_wap"},[_c('div'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.CHN))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.USA))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cde8c66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/titleStyle/titleStyle.vue
// module id = null
// module chunks = 